(() => {
  // Eğer OS/Browser "reduce motion" açık ise bile yine çalışsın diye kapatmadım.
  // İstersen en alta tekrar ekleriz.
  const SELECTOR = [
    '.featured-blog-posts-card',
    '.blog-post-card',
    '.resource-list__item',
    '.media',
    'img'
  ].join(',');

  // CSS yüklenmiyor / override ediliyor ihtimaline karşı CSS'yi JS ile enjekte ediyoruz.
  const ensureStyles = () => {
    if (document.getElementById('reveal-on-scroll-styles')) return;
    const style = document.createElement('style');
    style.id = 'reveal-on-scroll-styles';
    style.textContent = `
      .reveal-on-scroll{opacity:0;transform:translateY(18px);
        transition:opacity 520ms cubic-bezier(.22,1,.36,1),
                   transform 520ms cubic-bezier(.22,1,.36,1);
        will-change:opacity,transform}
      .reveal-on-scroll.is-revealed{opacity:1;transform:translateY(0)}
      @media (prefers-reduced-motion: reduce){
        .reveal-on-scroll{opacity:1;transform:none;transition:none}
      }
    `;
    document.head.appendChild(style);
  };

  ensureStyles();

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target);
    }
  }, { threshold: 0.18, rootMargin: '0px 0px -18% 0px' });

  const markAndObserve = (root = document) => {
  const nodes = root.querySelectorAll(SELECTOR);

  // Global sıra – tekrar init olsa bile bozulmaz
  window.__revealSeq = window.__revealSeq || 0;

  nodes.forEach((el) => {
    // Küçük ikonları atla
    if (el.tagName === 'IMG') {
      const w = el.naturalWidth || el.width || 0;
      if (w && w < 120) return;
    }

    // Zaten işlendiyse tekrar dokunma
    if (el.classList.contains('reveal-on-scroll')) return;

    const seq = window.__revealSeq++;
    const delay = Math.min(seq * 30, 150); // Apple vari stagger

    el.style.transitionDelay = `${delay}ms`;
    el.classList.add('reveal-on-scroll');

    requestAnimationFrame(() => {
      io.observe(el);
    });
  });
};

  const init = () => markAndObserve(document);

  // İlk yükleme
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor: section reload
  document.addEventListener('shopify:section:load', (e) => markAndObserve(e.target));

  // Horizon / page transition: içerik sonradan değişirse yakala
  const main = document.getElementById('MainContent') || document.body;
  const mo = new MutationObserver((mutations) => {
    // Yeni node geldiyse tekrar tarat
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        markAndObserve(main);
        break;
      }
    }
  });
  mo.observe(main, { childList: true, subtree: true });
})();